module.exports = __webpack_public_path__ + "img/home-step-icon-4.e945a9c2.png";